import {SearchOptions} from "@/variants/index.js";
import {Checkbox, Popover, Select} from "antd";
import styles from "./SearchBar.module.css";

export const SearchBar = ({
	showAll,
	equipment,
	operator,
	operators,
	onShowAllChange,
	onEquipmentChange,
	onOperatorChange,
}) => {
	function getSelectOptions() {
		if (!operators) return [];

		const baseItems = [
			{label: "Select all", value: "all", key: "all-opt"},
			{label: "Deselect all", value: "none", key: "none-opt"},
		];

		const groupedItems = operators.map(hub => ({
			key: hub.name,
			label: hub.name,
			options: (hub.operators || []).map(opt => ({
				key: opt,
				value: opt,
				label: opt,
			})),
		}));

		return [...baseItems, ...groupedItems];
	}

	function handleSelection(selectedValues) {
		if (selectedValues.includes("all")) {
			const allOperators = operators?.flatMap(hub => hub.operators || []) || [];
			onOperatorChange([...allOperators].sort());
			return;
		}

		if (selectedValues.includes("none")) {
			onOperatorChange([]);
			return;
		}

		onOperatorChange([...selectedValues].sort());
	}

	const selectOptions = getSelectOptions();

	return (
		<div data-testid="app-search-bar" className={styles.searchBarWrapper}>
			<label>
				{SearchOptions.includeOutOfStockLabel}:
				<Checkbox
					checked={showAll}
					onChange={event => onShowAllChange(event.target.checked)}
					data-testid="app-include-out-of-stock"
				/>
			</label>
			<label>
				Include equipment:
				<Checkbox
					checked={equipment}
					onChange={event => onEquipmentChange(event.target.checked)}
					data-testid="app-include-equipment"
				/>
			</label>
			<label>
				Choose operator:
				<Select
					name="operators"
					className={styles.selectOperators}
					maxTagCount={1}
					maxTagTextLength={15}
					maxTagPlaceholder={props => (
						<Popover content={props.map(v => v.label).join(", ")}>
							<span> + {props.length}</span>
						</Popover>
					)}
					value={operator}
					mode="multiple"
					variant="outlined"
					onChange={handleSelection}
					options={selectOptions}
					data-testid="app-operator-select"
				/>
			</label>
		</div>
	);
};
